import { ApprenticeshipRegistrationStatus } from "@/types/apprenticeship/apprentice";

export function get_apprenticeship_status_badge(status: ApprenticeshipRegistrationStatus) {
    const base = " rounded-sm px-2 py-0.5 text-xs font-medium";
    switch (status) {
        case "Pending":
            return <div className={`${base} bg-primary text-primary-foreground`}>A compléter</div>;
        case "Created":
            return <div className={`${base} bg-primary text-primary-foreground`}>Créer par un CS</div>;
        case "Fulfilled":
            return <div className={`${base}  bg-primary text-primary-foreground`}>Dossier complété</div>;
        case "CompanyFulfilled":
            return <div className={`${base}  bg-teal-600 text-white`}>Dossier complété</div>;
        case "Submitted":
            return <div className={`${base} border border-gray-400 bg-transparent text-gray-400`}>Analyse en cours</div>;
        case "NoShow":
            return <div className={`${base}  bg-gray-500 text-white`}>Absent au jury</div>;
        case "SearchingCompany":
            return <div className={`${base}  bg-amber-400 text-black`}>Recherche entreprise</div>;
        case "InterviewUpcoming":
            return <div className={`${base}  bg-primary text-primary-foreground`}>Entretien(s) à venir</div>;
        case "CompanyFound":
            return <div className={`${base}  bg-teal-600 text-white`}>Entreprise trouvée</div>;
        case "WaitingFeedback":
            return <div className={`${base}  bg-primary text-primary-foreground`}>Entretien(s) à venir</div>;
        case "ContractToBeSigned":
            return <div className={`${base}  bg-teal-600 text-white`}>Contrat à signer</div>;
        case "ContractSigned":
            return <div className={`${base}  bg-teal-600 text-white`}>Signé</div>;
        case "Discarded":
            return <div className={`${base}  bg-destructive text-destructive-foreground`}>Rejeté</div>;
        case "Abandonned":
            return <div className={`${base}  bg-gray-500 text-white`}>Abandonné</div>;
        case "Validated":
            return <div className={`${base}  bg-green-600 text-white`}>Validé</div>;
        case "Terminated":
            return <div className={`${base}  bg-red-500 text-white`}>Rupture</div>;
        case "Suspended":
            return <div className={`${base}  bg-red-500 text-white`}>Suspendu</div>;
        default:
            return <div className={`${base}  bg-gray-700 text-white`}>Inconnu</div>;
    }
}

/**
 * Return a human-readable English string expressing the time elapsed since the given date.
 * Examples: "now", "2 secs ago", "5 min ago", "3 days ago", "2 weeks ago".
 */
export function timeAgo(dateInput: Date | string | number | null | undefined): string {
    if (!dateInput) return "";

    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(date.getTime())) return "";

    const now = Date.now();
    const diffMs = now - date.getTime();

    if (diffMs < 1000) return "now";

    const sec = Math.floor(diffMs / 1000);
    if (sec < 60) return `${sec} sec${sec > 1 ? "s" : ""} ago`;

    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} min${min > 1 ? "s" : ""} ago`;

    const hour = Math.floor(min / 60);
    if (hour < 24) return `${hour} hour${hour > 1 ? "s" : ""} ago`;

    const day = Math.floor(hour / 24);
    if (day < 7) return `${day} day${day > 1 ? "s" : ""} ago`;

    const week = Math.floor(day / 7);
    if (week < 4) return `${week} week${week > 1 ? "s" : ""} ago`;

    const month = Math.floor(day / 30);
    if (month < 12) return `${month} month${month > 1 ? "s" : ""} ago`;

    const year = Math.floor(day / 365);
    return `${year} year${year > 1 ? "s" : ""} ago`;
}

export function get_apprenticeship_type_badge(type: "ContratPro" | "Apprentissage") {
    switch (type) {
        case "ContratPro":
            return <div className="rounded-sm border border-black px-2 py-0.5 text-xs font-medium text-black">C.P.</div>;
        case "Apprentissage":
            return <div className="rounded-sm border border-black px-2 py-0.5 text-xs font-medium text-black">App.</div>;
    }
}
